// components/chat/chat-input/studyToolsData.ts
import {
  BookOpenCheck,
  Network,
  GitBranch,
  BarChart3,
  ChartLine,
  PieChart,
  Brain,
  Globe,
  BookOpen,
  Settings2,
  MessageSquareText,
  FileText,
  Video,
  Music,
  Image,
  File,
  type LucideIcon,
} from "lucide-react";
import { TimelineIcon } from "@/components/icons/TimelineIcon";
import { VennDiagramIcon } from "@/components/icons/VennDiagramIcon";
import { FlashcardsIcon } from "@/components/icons/FlashcardsIcon";

export interface StudyTool {
  id: string;
  label: string;
  icon: LucideIcon;
  iconColor: string;
}

export const STUDY_TOOLS: StudyTool[] = [
  { id: "quiz", label: "Quiz", icon: BookOpenCheck, iconColor: "hsl(0, 84%, 60%)" },
  { id: "flashcards", label: "Flashcards", icon: FlashcardsIcon as any, iconColor: "hsl(217, 91%, 60%)" },
  { id: "mind-map", label: "Mind Map", icon: Network, iconColor: "hsl(263, 70%, 50%)" },
  { id: "flow-chart", label: "Flow Chart", icon: GitBranch, iconColor: "hsl(189, 94%, 43%)" },
  { id: "timeline", label: "Timeline", icon: TimelineIcon as any, iconColor: "hsl(38, 92%, 50%)" },
  { id: "bar-chart", label: "Bar Chart", icon: BarChart3, iconColor: "hsl(142, 71%, 45%)" },
  { id: "line-chart", label: "Line Chart", icon: ChartLine, iconColor: "hsl(330, 81%, 60%)" },
  { id: "pie-chart", label: "Pie Chart", icon: PieChart, iconColor: "hsl(263, 70%, 50%)" },
  { id: "venn-diagram", label: "Venn Diagram", icon: VennDiagramIcon as any, iconColor: "hsl(168, 76%, 42%)" },
];

// Additional context items that can be mentioned
export const CONTEXT_ITEMS: StudyTool[] = [
  { id: "learn-plus", label: "Learn+", icon: Brain, iconColor: "hsl(146, 50%, 50%)" },
  { id: "search", label: "Search", icon: Globe, iconColor: "hsl(217, 91%, 60%)" },
  { id: "study-mode", label: "Study Mode", icon: BookOpen, iconColor: "hsl(0, 84%, 60%)" },
];

// All mentionable items (study tools + context items)
const ALL_MENTION_ITEMS: StudyTool[] = [...STUDY_TOOLS, ...CONTEXT_ITEMS];

// Map of icon colors for dynamic content types
const CONTENT_TYPE_COLORS: Record<string, string> = {
  chat: "hsl(var(--primary))",
  pdf: "hsl(217, 91%, 60%)",
  document: "hsl(217, 91%, 60%)",
  video: "hsl(0, 84%, 60%)",
  audio: "hsl(263, 70%, 50%)",
  image: "hsl(142, 71%, 45%)",
};

export function getStudyToolById(id: string): StudyTool | undefined {
  // First check study tools and context items
  const found = ALL_MENTION_ITEMS.find((tool) => tool.id === id);
  if (found) return found;
  
  // Return undefined for dynamic content (handled by MentionNode with fallback)
  return undefined;
}

// Get icon color for any context item (including dynamic content)
export function getIconColorForItem(id: string, iconColor?: string): string {
  if (iconColor) return iconColor;
  
  const tool = getStudyToolById(id);
  if (tool) return tool.iconColor;
  
  // Default fallback
  return "hsl(var(--primary))";
}
